import Phaser from "phaser";
import $ from "jquery";
import config from "../helpers/config.js";
import { cst } from "../helpers/cst";

export default class Preload extends Phaser.Scene {
  constructor() {
    super(cst.scenes.preload);
  }

  preload() {
    this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      "bg-loading",
    );

    // Backgrounds
    this.load.image("bg-board", "assets/backgrounds/bg-board.png");
    this.load.image("bg-loading", "assets/backgrounds/bg-loading.png");
    this.load.image("bg-main", "assets/backgrounds/bg-main.png");
    this.load.image("bg-menu", "assets/backgrounds/bg-menu.png");
    this.load.image("bg-overlay", "assets/backgrounds/bg-overlay.png");
    this.load.image("bg-rules", "assets/backgrounds/bg-rules.png");

    // Buttons
    this.load.image("btn-login", "assets/buttons/btn-login.png");
    this.load.image("btn-sign-up", "assets/buttons/btn-sign-up.png");
    this.load.image(
      "btn-reset-password",
      "assets/buttons/btn-reset-password.png",
    );
    this.load.image(
      "btn-reset-password-2",
      "assets/buttons/btn-reset-password-2.png",
    );
    this.load.image("btn-buy-now", "assets/buttons/btn-buy-now.png");
    this.load.image("btn-play", "assets/buttons/btn-play.png");
    this.load.image("btn-rules", "assets/buttons/btn-rules.png");
    this.load.image("btn-next", "assets/buttons/btn-next.png");
    this.load.image("btn-next-bw", "assets/buttons/btn-next-bw.png");
    this.load.image("btn-back", "assets/buttons/btn-back.png");
    this.load.image("btn-menu", "assets/buttons/btn-menu.png");
    this.load.image("btn-play-again", "assets/buttons/btn-play-again.png");
    this.load.image("btn-roll", "assets/buttons/btn-roll.png");
    this.load.image("btn-roll-bw", "assets/buttons/btn-roll-disabled.png");
    this.load.image("btn-sound-off", "assets/buttons/sound-off.png");
    this.load.image("btn-sound-on", "assets/buttons/sound-on.png");
    this.load.image("btn-home", "assets/buttons/btn-home.png");
    this.load.image("btn-pause", "assets/buttons/btn-pause.png");

    // Errors
    this.load.image("error-empty-field", "assets/errors/error-empty-field.png");
    this.load.image(
      "error-user-not-found",
      "assets/errors/error-user-not-found.png",
    );
    this.load.image(
      "error-passwords-do-not-match",
      "assets/errors/error-passwords-do-not-match.png",
    );
    this.load.image(
      "error-invalid-code",
      "assets/errors/error-invalid-code.png",
    );
    this.load.image(
      "error-email-in-use",
      "assets/errors/error-email-in-use.png",
    );
    this.load.image(
      "error-email-not-exist",
      "assets/errors/error-email-not-exist.png",
    );
    this.load.image("error-generic", "assets/errors/error-generic.png");
    this.load.image("error-questions", "assets/errors/error-questions.png");
    this.load.image(
      "msg-reset-password",
      "assets/errors/msg-reset-password.png",
    );

    // Extras
    this.load.image("pawn", "assets/extras/pawn.png");
    this.load.image("clock", "assets/extras/clock.png");
    this.load.image("time-up", "assets/extras/time-up.png");
    this.load.image("box-login", "assets/extras/box-login.png");
    this.load.image("box-sign-up", "assets/extras/box-sign-up.png");
    this.load.image(
      "box-reset-password",
      "assets/extras/box-reset-password.png",
    );
    this.load.image("box-intro", "assets/extras/box-intro.png");
    this.load.image("box-score", "assets/extras/box-score.png");
    this.load.image("box-dice", "assets/extras/box-dice.png");
    this.load.image(
      "box-question-category-1",
      "assets/extras/box-question-category-1.png",
    );
    this.load.image(
      "box-question-category-2",
      "assets/extras/box-question-category-2.png",
    );
    this.load.image(
      "box-question-category-3",
      "assets/extras/box-question-category-3.png",
    );
    this.load.image(
      "box-question-category-4",
      "assets/extras/box-question-category-4.png",
    );
    this.load.image(
      "box-question-category-5",
      "assets/extras/box-question-category-5.png",
    );
    this.load.image(
      "box-question-category-6",
      "assets/extras/box-question-category-6.png",
    );
    this.load.image(
      "box-question",
      "assets/extras/box-question.png",
    );
    this.load.image(
      "box-category", 
      "assets/extras/box-category.png"
    );
    this.load.image(
      "box-congratulations",
      "assets/extras/box-congratulations.png",
    );
    this.load.image(
      "box-no-more-questions",
      "assets/extras/box-no-more-questions.png",
    );
    this.load.image("box-end", "assets/extras/box-end.png");
    this.load.image("checkbox", "assets/extras/checkbox.png");
    this.load.image("checkbox-bw", "assets/extras/checkbox-bw.png");
    this.load.image("tick", "assets/extras/tick.png");
    this.load.image("cross", "assets/extras/cross.png");

    // Sounds
    this.load.audio("snd-click", "assets/sounds/snd-click.mp3");
    this.load.audio("snd-correct", "assets/sounds/snd-correct.mp3");
    this.load.audio("snd-wrong", "assets/sounds/snd-wrong.mp3");
    this.load.audio("snd-pop", "assets/sounds/snd-pop.mp3");
    this.load.audio("snd-roll", "assets/sounds/snd-roll.mp3");
    this.load.audio(
      "snd-congratulations",
      "assets/sounds/snd-congratulations.mp3",
    );
    this.load.audio("snd-pawn-movement", "assets/sounds/snd-pawn-movement.mp3");

    // SpriteSheets
    this.load.spritesheet({
      key: "btn-category-1",
      url: "assets/buttons/btn-category-1.png",
      frameConfig: {
        frameWidth: 365.5,
        frameHeight: 101,
      },
    });
    this.load.spritesheet({
      key: "btn-category-2",
      url: "assets/buttons/btn-category-2.png",
      frameConfig: {
        frameWidth: 365.5,
        frameHeight: 101,
      },
    });
    this.load.spritesheet({
      key: "btn-category-3",
      url: "assets/buttons/btn-category-3.png",
      frameConfig: {
        frameWidth: 365.5,
        frameHeight: 101,
      },
    });
    this.load.spritesheet({
      key: "btn-category-4",
      url: "assets/buttons/btn-category-4.png",
      frameConfig: {
        frameWidth: 365.5,
        frameHeight: 101,
      },
    });
    this.load.spritesheet({
      key: "btn-category-5",
      url: "assets/buttons/btn-category-5.png",
      frameConfig: {
        frameWidth: 365.5,
        frameHeight: 101,
      },
    });
    this.load.spritesheet({
      key: "btn-category-6",
      url: "assets/buttons/btn-category-6.png",
      frameConfig: {
        frameWidth: 365.5,
        frameHeight: 101,
      },
    });
    this.load.spritesheet({
      key: "sprite-dice",
      url: "assets/spritesheets/spritesheet-dice.png",
      frameConfig: {
        frameWidth: 190.16,
        frameHeight: 191,
      },
    });
    this.load.spritesheet({
      key: "sprite-dice-roll",
      url: "assets/spritesheets/spritesheet-dice-rolling.png",
      frameConfig: {
        frameWidth: 190.16,
        frameHeight: 191,
      },
    });
    this.load.spritesheet({
      key: "sprite-firework-blue",
      url: "assets/spritesheets/spritesheet-fireworks-blue.png",
      frameConfig: {
        frameWidth: 384.03,
        frameHeight: 385,
      },
    });
    this.load.spritesheet({
      key: "sprite-firework-yellow",
      url: "assets/spritesheets/spritesheet-fireworks-yellow.png",
      frameConfig: {
        frameWidth: 384.03,
        frameHeight: 385,
      },
    });
    this.load.spritesheet({
      key: "sprite-progress-bar",
      url: "assets/spritesheets/spritesheet-progress-bar.png",
      frameConfig: {
        frameWidth: 292,
        frameHeight: 65,
      },
    });

    this.load.html("html-first-name", "html/first-name.html");
    this.load.html("html-last-name", "html/last-name.html");
    this.load.html("html-email", "html/email.html");
    this.load.html("html-password", "html/password.html");
    this.load.html(
      "html-password-confirmation",
      "html/password-confirmation.html",
    );
    this.load.html("html-product-code", "html/product-code.html");
    this.load.html("html-verification-code", "html/verification-code.html");

    this.load.on("complete", async () => {
      let self = this;

      if (config.online) {
        $.ajax({
          async: false,
          type: "get",
          url: "api/authorization.php",
          headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` },
          dataType: "JSON",
          success(response) {
            console.log(response);
            response[0] === 400
              ? self.scene.start(cst.scenes.login)
              : self.scene.start(cst.scenes.menu);
          },
          error(error) {
            console.log(error);
          },
        }).responseJSON;
      } else {
        this.scene.start(cst.scenes.menu);
      }
    });
  }

  create() {}

  upload() {}
}
